import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultType, JudgmentResultEnum } from "../../types.client";
import { parseRangeValue } from "../../utils/parseValue.utils";
import { OutputTerminalLevelMeasure } from "../../../models/schemas/measures/communication.schema";

/**
 * 출력검사단자 레벨값 컨트롤러
 * 판정 기준: min <= 측정값 <= max
 */
export class OutputTerminalLevelController extends MeasureController<OutputTerminalLevelMeasure> {
  protected getDefaultData(): OutputTerminalLevelMeasure {
    return {
      standardValue: "",
      measuredValue: 0,
      unit: "dBuV",
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
    };
  }

  protected judge(): JudgmentResult {
    const { standardValue, measuredValue } = this.data;

    // 데이터 미입력 시
    if (!standardValue || measuredValue === undefined || measuredValue === null) {
      return {
        result: JudgmentResultEnum.NA,
        discussion: this.generateDiscussion(JudgmentResultEnum.NA),
      };
    }

    // parseRangeValue 사용: "60~80 dBuV" → { min: 60, max: 80 }
    const range = parseRangeValue(standardValue);

    if (!range) {
      return {
        result: JudgmentResultEnum.NA,
        discussion: "기준값 파싱 실패 (올바른 범위 형식: '60~80 dBuV')",
      };
    }

    // 판정: min <= 측정값 <= max
    const result: JudgmentResultType =
      measuredValue >= range.min && measuredValue <= range.max
        ? JudgmentResultEnum.GOOD
        : JudgmentResultEnum.BAD;

    return {
      result,
      discussion: this.generateDiscussion(result),
    };
  }

  protected generateDiscussion(result: JudgmentResultType): string {
    if (result === JudgmentResultEnum.NA) {
      return "데이터 미입력";
    }

    const { standardValue, measuredValue } = this.data;
    const range = parseRangeValue(standardValue);

    if (!range) {
      return "기준값 범위 파싱 실패";
    }

    if (result === JudgmentResultEnum.GOOD) {
      return `출력검사단자 레벨값이 기준 범위(${range.min}~${range.max} dBuV) 내에 있음`;
    }

    return `출력검사단자 레벨값이 기준 범위를 벗어남 (${measuredValue} dBuV, 정상: ${range.min}~${range.max} dBuV)`;
  }
}
